import { AppModule } from "@/shared/app";

import { plmResourceModules } from "./plm/resourceModules";

const appModules: {
  [app: string]: { [moduleName: string]: AppModule };
} = {
  plm: plmResourceModules,
};

export function getResourceModule(appLabel: string, resourceName: string) {
  return appModules[appLabel][resourceName];
}
